module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Quản lý permissions"
    }
  }, [_c('router-link', {
    staticClass: "ui mini blue button",
    attrs: {
      "to": {
        name: 'create-permission'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Thêm mới")])], 1), _vm._v(" "), _c('div', {
    staticClass: "padding-sm-all"
  }, [_c('gs-table', {
    ref: _vm.permissionTable,
    attrs: {
      "table-name": _vm.permissionTable,
      "data-source": "permissions",
      "data-params": _vm.filters,
      "data-sorted": _vm.sorted,
      "data-sorts": _vm.sorts
    },
    on: {
      "remove-filter": _vm.removeFilter
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(datas) {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": datas.data,
            "border": ""
          }
        }, [_vm._v("\n        >\n          "), _c('el-table-column', {
          attrs: {
            "label": "#",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(_vm.dataPaginations[_vm.permissionTable]) ? _c('small', [_vm._v(_vm._s((scope.$index + 1) + ((_vm.dataPaginations[_vm.permissionTable].current_page - 1) * _vm.dataPaginations[_vm.permissionTable].per_page)))]) : _vm._e()]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tên hiển thị",
            "width": "200"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.display_name))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Mô tả"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.description))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "Tạo lúc"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('p', [_vm._v(_vm._s(scope.row.created_at))])]
            }
          }], null, true)
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "95"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('section', {
                staticClass: "padding-sm-top padding-sm-bottom"
              }, [_c('el-tooltip', {
                staticClass: "display-inline",
                attrs: {
                  "placement": "top",
                  "content": "Xóa"
                }
              }, [_c('a', {
                staticClass: "text-red padding-all display-inline-block cursor-pointer",
                on: {
                  "click": function($event) {
                    $event.preventDefault();
                    return _vm.deletePermission(scope.row)
                  }
                }
              }, [_c('i', {
                staticClass: "fa fa-trash"
              })])])], 1)]
            }
          }], null, true)
        })], 1)]
      }
    }])
  }, [_c('section', {
    attrs: {
      "slot": "filters"
    },
    slot: "filters"
  })])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a8e2806"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/permission/Permission.vue
// module id = 641
// module chunks = 1